<template>
  <div class="fill-height d-flex flex-column flex-grow-1">
    <h2>ŠKODE</h2>
    <h3 class="mt-5">REPORT</h3>

    <h5>CR:{{ cr }}</h5>
    <v-card class="about pa-4 fill-height">
      <div class="display-1">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Itaque veritatis ad illo nesciunt laudantium excepturi
        ratione mollitia enim consequatur, beatae recusandae adipisci impedit nam quidem nulla dolorum voluptate aut
        sequi!
      </div>
      <div class="display-1">
        Sit, iusto. Omnis assumenda molestiae nulla sequi nihil vel natus quis voluptate voluptas error? Praesentium
        corporis quia nemo aut odit ea minus quasi molestias, hic officiis assumenda vel ullam nisi.
      </div>
      <router-view></router-view>
    </v-card>
  </div>
</template>

<script>
export default {
  computed: {
    cr() {
      return this.$route.name;
    },
  },
};
</script>
